export default "__VITE_ASSET__CgFMwCTT__"